import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { OverridablePropertiesFieldState } from '@/common/constants';
import { API_URL } from '@/dtos';

const useGetOverridablePropertiesFieldState = (enabled: boolean) => {
  const { data, isLoading, isSuccess } = useQuery(
    [API_URL.ENUMS_OVERRIDABLE_PROPERTIES_FIELD_STATE, enabled],
    // TODO: the dto type is missing
    () => api.get<OverridablePropertiesFieldState>(API_URL.ENUMS_OVERRIDABLE_PROPERTIES_FIELD_STATE),
    { enabled }
  );

  return {
    overridablePropertiesFieldState: data?.data || null,
    isLoading,
    isSuccess,
  };
};

export default useGetOverridablePropertiesFieldState;
